import catalog from '../data/cultivarCatalog.json';

// Names only: no invented growing traits, GEU artwork, cultivar authenticity or AI identity claims.
export const normalizeCultivar = value => String(value || '').normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase().replace(/[’‘]/g, "'").replace(/\s+/g, ' ').trim();
export const cultivarMatches = (option, query) => {
  const haystack = normalizeCultivar([option.label, ...(option.aliases || [])].join(' '));
  return normalizeCultivar(query).split(' ').filter(Boolean).every(word => haystack.includes(word));
};
export const NAMED_CULTIVARS = Object.fromEntries(catalog.groups.map(group => [group.species,
  group.labels.map(label => ({ key: normalizeCultivar(label).replace(/[^a-z0-9]+/g, '-'), label, kind: 'cultivar', source: group.source }))]));
export const NAMED_CULTIVAR_COUNT = catalog.groups.reduce((sum, group) => sum + group.labels.length, 0);
export const filterCultivars = (options, query = '', kind = 'all') => options.filter(option =>
  (kind === 'all' || (option.kind || 'legacy') === kind) && cultivarMatches(option, query));
